import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'la-image-picker',
  template: `<label for="file_upload">
    <input id="file_upload" type="file" (change)="fileEvent($event)">
    <div class="la-image-picker_circle"
         [ngStyle]="{'background-image' : (file === '') ? 'linear-gradient(rgba(54, 68, 79, 0.4), rgba(54, 68, 79, 0.4))' :
          'url(assets/images/' + file + ')'}">
      <div class="la-image-picker_input">
        <div>
          <div class="pt-1 text-center">
            <la-icon name="photos" color="white"></la-icon>
          </div>
          <div class="pt-1 la-image-picker_text text-center">
            <la-text kind="title-3" color="white">
              <ng-content></ng-content>
            </la-text>
          </div>
        </div>
      </div>
    </div>
  </label>    `,
  styles: [`
    .la-image-picker_circle{width:264px;height:264px;border-radius:50%;cursor:pointer;padding:55px}.la-image-picker_circle:hover{box-shadow:0 0 15px 0 rgba(234,235,237,.74);opacity:.7}.la-image-picker_input{width:155px;height:155px;display:flex;align-items:center;justify-content:center;border-radius:50%;border:3px dashed #fff}input{width:0;height:0;visibility:hidden}.la-image-picker_text{padding:0 40px}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaImagePickerComponent {
  private file = '';

  fileEvent(e: any) {
    const file = e.target.value;
    this.file = file.substring(12) ;
   console.log(this.file);
  }
}
